import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { defaultLocale } from 'server/i18n'
import MustHeader from 'components/business/shared/MustHeader'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/business/shared/GoogleTagManager'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import GlobalStyle from 'styles'

export default function SignupLayout(props) {
  const { children, config } = props
  const title = props.title
    ? props.title
    : i18n.t('server.business.shared.default_title')
  const siteName = i18n.t('server.business.shared.default_site_name')
  const description = i18n.t(
    props.description || 'server.business.shared.default_description',
  )
  const image = props.image || imagePath('business/ogp_business.png')
  const url = props.url || ''
  const bodyClassNames = ['site-business']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  const meta = {
    title: `${title} - ${i18n.t('server.business.shared.default_title')}`,
    description,
    og: {
      title,
      description,
      url,
      image,
      siteName,
      type: 'website',
      locale: defaultLocale,
    },
    twitter: {
      title,
      description,
      url,
      image: { src: image },
      card: '',
      site: '@spacemarketjp',
      creator: '@spacemarketjp',
    },
  }

  function renderAll(element) {
    return (
      <html>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <script defer src="https://code.getmdl.io/1.2.1/material.min.js" />
          <title>{title}</title>
          <meta name="description" content={description} />
          <link rel="shortcut icon" href={imagePath('business/favicon.ico')} />
          <meta property="fb:app_id" content={props.config.FB_APP_ID} />
          <meta property="og:site_name" content={meta.og.siteName} />
          <meta property="og:title" content={meta.og.title} />
          <meta property="og:description" content={meta.og.description} />
          <meta property="og:type" content={meta.og.type} />
          <meta property="og:url" content={meta.og.url} />
          <meta property="og:locale" content={meta.og.locale} />
          <meta property="og:image" content={meta.og.image} />
          <link
            rel="stylesheet"
            href={manifest['business/main.css']}
            media="screen"
          />
          <link
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            rel="stylesheet"
          />
          <link rel="shortcut icon" href={imagePath('business/favicon.ico')} />
          <meta
            name="google-site-verification"
            content="cmoKhQQsQ4qUSCi8OyEvVogn5rLN77ObhTYe5pWXcBk"
          />
          <GoogleTagManagerHead />
          <script
            src="https://browser.sentry-cdn.com/4.5.4/bundle.min.js"
            crossOrigin="anonymous"
          />
        </head>
        <body className={bodyClassNames.join(' ')}>
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
          <GlobalStyle />
        </body>
      </html>
    )
  }

  function renderRoot() {
    return (
      <div>
        <header>
          <div className="dashboard-container">
            <div className="site-header clearfix">
              <p className="fl">
                <a href={wwwUrl('')} className="site-header__logo">
                  {i18n.t('spacemarket')}
                </a>
              </p>
            </div>
          </div>
        </header>
        <div className="site-main">{children}</div>
        <footer>
          <div className="site-footer base__padding ta-c">
            <small>
              <img
                src={imagePath('footer/logo_spmkt.png')}
                height="12"
                width="109"
                alt="SPACEMARKET"
              />
              {i18n.t('page.shared.l_00068')}
            </small>
          </div>
        </footer>
      </div>
    )
  }
  return config.SSR ? renderAll() : renderRoot()
}
